module.exports = __webpack_public_path__ + "area_chuanyu_dark.0360b606.png";